$(document).on('turbolinks:load', function() {
  $(document).find('.link-disabled').on('click',function(e){
    e.stopImmediatePropagation()
    e.preventDefault();
  });

  $(document).on('click', '.close-desktop', function(){
    $(this).parent().parent().parent().addClass('active');
    $(document).find('.dashboard-content-container').addClass('active-navbar');
  });

  $(document).on('click', '.open-desktop', function(){
    $(this).parent().parent().parent().removeClass('active');
    $(document).find('.dashboard-content-container').removeClass('active-navbar');
  });


  $(document).on('click', '.close-mobile', function(){
    $(this).parent().parent().parent().removeClass('active-mobile');
  });

  $(document).on('click', '.open-mobile', function(){
    $(this).parent().parent().parent().addClass('active-mobile');
  });

  $(window).on('resize', function(e) {
    $(document).find('.nav-bar').removeClass('active-mobile');
  });

  $(document).on('click', '.dashboard-content-container', function(){
    $(document).find('.nav-bar').removeClass('active-mobile');
  });

  $(document).on('click', 'a .nav-expand-more', function(e){
    e.preventDefault();
    $(this).parent().find('.nav-expand-less').css('display', 'inline-block');
    $(this).parent().find('.nav-expand-more').hide();
    id = $(this).attr('data-target');
    $(document).find(`.${id}`).css('display', 'flex');
  });

  $(document).on('click', 'a .nav-expand-less', function(e){
    e.preventDefault();
    $(this).parent().find('.nav-expand-less').hide();
    $(this).parent().find('.nav-expand-more').css('display', 'inline-block');
    id = $(this).attr('data-target');
    $(document).find(`.sub-li.${id}`).hide();
  });

  var element = document.querySelector('.current');
  if (element) {
    var classList = element.classList;
    var classes = Array.from(classList);
    var hasVideoCenterTarget = classes.includes('video-center-target');
    if (hasVideoCenterTarget) {
      var expandMoreButton = document.getElementsByClassName('nav-expand-more')[0];
      if (expandMoreButton) {
        expandMoreButton.click();
      }
    }
  }
});
